import axios from 'axios';
import { AuthResponse, OnlineUsersResponse } from '../types';

const API_BASE_URL = 'https://voicechatapi.kasaneko.com';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// リクエストインターセプター（トークン自動付与）
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// レスポンスインターセプター（エラーハンドリング）
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // トークンが無効な場合、ログアウト
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  register: async (username: string, password: string): Promise<AuthResponse> => {
    const response = await api.post('/api/auth/register', { username, password });
    return response.data;
  },

  login: async (username: string, password: string): Promise<AuthResponse> => {
    const response = await api.post('/api/auth/login', { username, password });
    return response.data;
  },

  logout: async (): Promise<{ success: boolean; message: string }> => {
    const response = await api.post('/api/auth/logout');
    return response.data;
  },

  getMe: async (): Promise<AuthResponse> => {
    const response = await api.get('/api/auth/me');
    return response.data;
  },

  requestPasswordReset: async (email: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.post('/api/auth/request-password-reset', { email });
    return response.data;
  },

  resetPassword: async (
    email: string,
    code: string,
    newPassword: string
  ): Promise<{ success: boolean; message: string }> => {
    const response = await api.post('/api/auth/reset-password', {
      email,
      code,
      newPassword,
    });
    return response.data;
  },
};

export const userAPI = {
  getOnlineUsers: async (): Promise<OnlineUsersResponse> => {
    const response = await api.get('/api/users/online');
    return response.data;
  },

  updatePosition: async (userId: string, position: { x: number; y: number; z: number }): Promise<any> => {
    const response = await api.put('/api/users/position', { userId, position });
    return response.data;
  },

  updateProfile: async (userId: string, avatar?: string): Promise<any> => {
    const response = await api.put('/api/users/profile', { userId, avatar });
    return response.data;
  },

  deleteAccount: async (userId: string, currentPassword: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete(`/api/users/${userId}`, {
      data: { currentPassword },
    });
    return response.data;
  },
};

export default api;
